import { datadogLogs } from "@datadog/browser-logs";

type PortalEnv = "dev" | "staging" | "production";

const getEnv = (): PortalEnv => {
  const host = window.location.hostname;

  if (
    host === "on-demand-join-ui-dev.kubes.jointheteam.aus.com" ||
    host === "localhost"
  ) {
    return "dev";
  }

  if (host === "on-demand-join-ui-staging.kubes.jointheteam.aus.com") {
    return "staging";
  }

  if (host === "jointheteam.aus.com") {
    return "production";
  }

  throw new Error("Cannot identify environment");
};

datadogLogs.init({
  service: "lisaui",
  env: getEnv(),
  clientToken: "pub53593a4ff7c67498d883020ad3e5bf8d",
  site: "datadoghq.com",
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

export default datadogLogs;
